import React, { useRef } from "react";
import { connect } from "react-redux";
import { Component } from "react/lib/ReactBaseClasses";
import languageContainer from "../../../containers/user/language";
import globe from "../../../asset/img/globe.svg";
import turkish from "../../../asset/img/Turkey_flat.png";
import english from "../../../asset/img/United-Kingdom_flat.png";
import InfoTooltip from "../../common/tooltip/info";
import { withNamespaces } from 'react-i18next';

class LanguagesMenu extends Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    const { isLanguageMenuOpen, handelClick, changeLanguage, t } = this.props;
    return (
      <div>
        <InfoTooltip info={t('languageTooltip')} placement="bottom">
          <button
            type="button"
            className="languages-button"
            onClick={() => handelClick("language")}
          >
            <img src={globe} className="languages-icon" />
          </button>
        </InfoTooltip>

        {isLanguageMenuOpen ? (
          <div
            className="languages-button-menu"
            ref={(node) => (this.node = node)}
          >
            <span
              className="language-menu-item"
              onClick={() => changeLanguage("tr")}
            >
              <img
                src={turkish}
                alt="logo"
                style={{ width: "25px", marginRight: "10px" }}
              />
              <span style={{ verticalAlign: "middle" }}>TR</span>
              <hr />
            </span>
            <span
              className="language-menu-item"
              onClick={() => changeLanguage("en")}
            >
              <img
                src={english}
                alt="logo"
                style={{ width: "25px", marginRight: "10px" }}
              />
              <span style={{ verticalAlign: "middle" }}>EN</span>
              <hr />
            </span>
          </div>
        ) : null}
      </div>
    );
  };
}

export default withNamespaces()(connect(...languageContainer)(LanguagesMenu));



// WEBPACK FOOTER //
// ./src/components/header/languages-menu/index.js